import script from "./StaffDatatableFormDoctorForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StaffDatatableFormDoctorForm.vue?vue&type=script&setup=true&lang=js"

import "./StaffDatatableFormDoctorForm.vue?vue&type=style&index=0&id=e9e2a784&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9e2a784"]])

export default __exports__